import { useCallback, useMemo } from "react";

import { hasAnyPermission, hasPermission } from "@/lib/permissions";
import { useAuth } from "@/stores/authStore";

/**
 * Client-side permission checks against the principal's effective set
 * (returned by `/auth/me`). Mirrors the backend deny-by-default model.
 */
export function usePermissions() {
  const { user } = useAuth();
  const effective = useMemo(() => user?.permissions ?? [], [user?.permissions]);

  const has = useCallback(
    (...required: string[]) => hasPermission(effective, ...required),
    [effective],
  );
  const any = useCallback(
    (...wanted: string[]) => hasAnyPermission(effective, ...wanted),
    [effective],
  );

  return { permissions: effective, has, any };
}
